// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"70548a54","277":"85e597c8","310":"ac253809","763":"dd81e6ed","972":"4a820714"}[chunkId] + ".chunk.css";
};